import React, { useState } from "react";
import EventAppImageEditor from "./EventAppImageEditor";
import { getUrlFromUserFile, objectUrlToDataUrl } from "../../utils/UrlHelpers";
import { getResizedImageObjectUrl } from "./ImageEditorExtensions";
import Icon, { IconType } from "../Icon/Icon";
import { useEffect } from "react";
import Modal from "../Modal/Modal";
import { UiFormField } from "../../utils/CommonTypes/UserTypes";
import StoreX, { store } from "../../redux/oldStore";
import { ServerResponse } from "../../utils/Server";
import { toast } from "react-toastify";

export interface IImageInfo {
  name?: string | null | undefined;
  text?: string | null | undefined;
  id?: string | undefined;
  inputType?: string | null | undefined;
  dataUrl?: string | null | undefined;
  fieldKey: string;
  key?: string | undefined;
}

interface ImageLoadingProps {
  imageInfo?: IImageInfo;
  setImageInfo?: (imageInfo: any) => void;
  imageValue?: string | null;
  clearInfo?: boolean;
  handleRemoveImage?: (e, fieldKey: string) => void;
  handleLoadClick?: () => void;
  fieldKey: string;
  field: UiFormField;
}

const ImageLoading = (props: ImageLoadingProps) => {
  const defaultUploadState = {
    isImageUploadVisible: false,
    imageUploadSave: (url: string) => {},
    imageFileUrl: "",
    imageFileName: "",
    imageOtherInfo: {},
    fieldKey: props.fieldKey,
  };
  const [imageUploadstate, setInputUploadState] = useState(defaultUploadState);
  const [field, setField] = useState<IImageInfo>();
  const [profileImageFailedToLoad, setProfileImageFailedToLoad] =useState<Boolean>();
  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [flipKey, setFlipKey] = useState<number>(0);

  useEffect(() => {
    if (props.clearInfo) {
      clearInputs();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.clearInfo]);

  const handleUploadClick = async (e, id: string) => {
    e.preventDefault();
    let result = await getUrlFromUserFile({ urlType: "DataUrl" });
    let sizedUrl = await getResizedImageObjectUrl(result.url);
    saveUploadFile(id, result.filename, sizedUrl);
  };

  const clearInputs = () => {
    setInputUploadState(defaultUploadState);
    setField(undefined);
  };

  const handleRemoveClick = (e) => {
    if(true || window.confirm(`Are you sure you want to remove this image?`)){
    clearInputs();
    props.handleRemoveImage?.(e, props.fieldKey);}
  };

  const setImageBoolean = () => {
    setInputUploadState({
      ...imageUploadstate,
      isImageUploadVisible: !imageUploadstate.isImageUploadVisible,
    });
  };

  const handleThumbnailClick = () => {
    // let fieldThatMatches = props.fullFile?.preFillFields?.filter(x => x.id === field.id)?.[0]
    setInputUploadState({
      imageFileUrl: field?.dataUrl ?? "",
      imageFileName: field?.text ?? "new",
      imageUploadSave: (url: string) =>
        saveUploadFile(field?.id ?? "", field?.text ?? "", url),
      imageOtherInfo: {},
      isImageUploadVisible: true,
      fieldKey: props.fieldKey,
    });
  };

  const saveUploadFile = async (
    id: string,
    filename: string,
    objectUrl: string
  ) => {
    const dataUrl = await objectUrlToDataUrl(objectUrl);
    let updatedFormData: IImageInfo = {
      ...field,
      dataUrl: dataUrl,
      text: filename,
      fieldKey: props.fieldKey,
    };
    setField(updatedFormData);
    setInputUploadState({
      ...imageUploadstate,
      isImageUploadVisible: false,
    });
    props?.setImageInfo?.(updatedFormData);
  };

  const handleImagePreviewClick = () => {
    setShowPreview(true);
  };

  const guidRegex = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}(?=$|[^0-9a-fA-F])/g;

// Function to get the last GUID
const getLastGuid = (input: string) => {
  const matches = [...input.matchAll(guidRegex)];
  return matches.length > 0 ? matches[matches.length - 1][0] : null;
}

  const rotateImage = (deg: number) => {
    if (!field?.key && !props?.imageValue) return;


    let imageKey = getLastGuid(field?.key ?? props?.imageValue);

    if (imageKey) {
      store.server
        .postApi<ServerResponse<any>>("../API/image/UpdateImage", {
          key: imageKey,
          rotate: deg,
        })
        .then((res) => {
          if (res.Success) {
            setFlipKey(flipKey + 1);
            // Update field to trigger re-render
            if (field) {
              let updatedFormData: IImageInfo = {
                ...field,
              };
              setField(updatedFormData);
              props?.setImageInfo?.(updatedFormData);
            }
          } else {
            toast.error(`Failed to rotate image: ${res.Message}`);
          }
        });
    } else {
      console.log("No image key available for rotation.", props);
    }
  };

  const handleDeleteImage = () => {
    if (
      window.confirm(
        `Are you sure you want to delete this profile image?`
      )
    ) {
      handleRemoveClick(null);
      setShowPreview(false);
    }
  };

  const getUrl = (url: string) => {
    //if url is json set url to dataUrl
    if (url.startsWith("{")) {
      const json = JSON.parse(url);
      url = json.dataUrl;
    }
    //if data url, return as is
    if (url.startsWith("data:")) return url;
    return url + (url.includes("?") ? "&" : "?") + `flipKey=${flipKey}`;
  }

  return (
    <div className="profile profile-image-container">
        <div className="profile profile-image">
      {field?.dataUrl || props.imageValue ? 
        <>
          {!profileImageFailedToLoad ? 
          <>
            <img
            src={ getUrl(field?.dataUrl ?? props?.imageValue ?? "")}
            alt={"profile"} 
            className="click"
            onClick={handleImagePreviewClick}
            onError={(x)=>{
              setProfileImageFailedToLoad(true);
            }} />
            </>
            :<>
            <Icon type={IconType.userProfileImage} />
            </>}
            </>
            
           
       : (
        <div className="click huge" onClick={(e) => handleUploadClick(e, field?.id ?? "")} ><Icon type={IconType.user}></Icon>
        </div>
      )}
        </div>
      <div>
        <span className="click btn" title="select image to upload" onClick={(e) => handleUploadClick(e, field?.id ?? "")}><Icon type={IconType.upload} /></span>
        {(props.imageInfo ||
          props.imageValue ||
          imageUploadstate.imageFileUrl) && (
            <><br/><span className="click btn" title="remove image" onClick={handleRemoveClick}><Icon type={IconType.trashO} /></span></>
        )}
        { field?.dataUrl &&
          <><br/><span className="click btn" title="edit image" onClick={handleThumbnailClick}><Icon type={IconType.edit} /></span></>
        }
      </div>
      {props.field.AdditionalInformation && <div dangerouslySetInnerHTML={{__html:props.field.AdditionalInformation}}></div>}
      {imageUploadstate.isImageUploadVisible && (
        <Modal
          setModalOpen={setImageBoolean}
          title=" "
          className="image-modal-sizer"
          // isOpen={imageUploadstate.isImageUploadVisible}
          // toggle={setImageBoolean}
        >
            <EventAppImageEditor
              imageName={imageUploadstate.imageFileName}
              imageUrl={imageUploadstate.imageFileUrl}
              saveImage={imageUploadstate.imageUploadSave}
              imageOtherInfo={imageUploadstate.imageOtherInfo}
            />
        </Modal>
      )}

      {showPreview && (field?.dataUrl || props.imageValue) && (
        <Modal
          setModalOpen={setShowPreview}
          title="Profile Image"
          className="file-input-preview-sizer"
        >
          <>
            <div className="file-preview">
              <img
                className="gallery-image-x file-preview-grow"
                src={getUrl(field?.key ? StoreX.BuildUrl(`/File/${field.key}`) : (field?.dataUrl ?? props?.imageValue ?? ""))}
                alt="profile preview"
              />
              <div className="gallery-control-panel">
                <button
                  type="button"
                  className="btn btn-default btn-sm"
                  title="Delete profile image"
                  onClick={handleDeleteImage}
                >
                  <Icon type={IconType.delete} />
                  Delete File
                </button>
                {field?.key && (
                  <a
                    href={StoreX.BuildUrl(getUrl(`/File/Image/${field.key}`))}
                    target="_blank"
                    title="view file"
                    rel="noreferrer"
                  >
                    Open
                  </a>
                )}
                <div>
                  <span
                    className="click"
                    title="rotate image left"
                    onClick={() => {
                      rotateImage(270);
                    }}
                  >
                    <Icon type={IconType.redo} flipHorizontal={true} />
                  </span>
                  <span
                    className="click"
                    title="rotate image right"
                    onClick={() => {
                      rotateImage(90);
                    }}
                  >
                    <Icon type={IconType.redo} />
                  </span>
                </div>
              </div>
            </div>
          </>
        </Modal>
      )}
    </div>
  );
};

export default ImageLoading;
